import { NgModule } from '@angular/core';
import { BaseModule, DISTINCT_ITEMS_SOURCE, ITEM_FILTER_SOURCE } from '@shared';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportService } from './services';
import { ItemService, SharedDataModule } from '@shared-data';
import { ReportsComponent } from './reports.component';
import {
  AuditComponent,
  DeliveryExceptionsComponent,
  ExceptionsComponent,
  FailuresComponent,
  HistoryComponent,
  HistorySummaryComponent,
  ModifierExceptionComponent,
  PricingExceptionsComponent,
  SubstitutionsExceptionComponent,
  SyncExceptionsComponent,
  ZeroPriceReportComponent,
} from './components';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AuditComponent,
    HistoryComponent,
    ReportsComponent,
    FailuresComponent,
    ExceptionsComponent,
    DeliveryExceptionsComponent,
    PricingExceptionsComponent,
    ZeroPriceReportComponent,
    ModifierExceptionComponent,
    SubstitutionsExceptionComponent,
    SyncExceptionsComponent,
    HistorySummaryComponent,
  ],
  imports: [BaseModule, ReportsRoutingModule, SharedDataModule],
  exports: [ReportsComponent],
  providers: [
    DatePipe,
    { provide: DISTINCT_ITEMS_SOURCE, useExisting: ReportService },
    { provide: ITEM_FILTER_SOURCE, useExisting: ItemService },
  ],
})
export class ReportsModule {}
